var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-root',{staticClass:"main-layout"},[_c('AppHeader'),_vm._v(" "),_c('div',[_c('nuxt')],1),_vm._v(" "),_c('app-footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAppFooter),expression:"showAppFooter"}]}),_vm._v(" "),_c('LoginDialog'),_vm._v(" "),_c('ContactDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }